import { Component } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { FlatpickrModule } from 'angularx-flatpickr';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, FlatpickrModule, IconModule, MaterialModule],
  selector: 'app-card-outer',
  templateUrl: './card-outer.component.html',
  styleUrl: './card-outer.component.scss'
})
export class CardOuterComponent {

}
